'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _JobAdsFront = _interopRequireDefault(require("Components/Lists/JobAdsFront"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let app = window.app;
class JobAdCompanyPage extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const user = app?.state?.session?.user;
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Mes annonces | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title c-title--center "
    }, "Mes annonces"), user.create_jobad === true ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex u-content-center u-margin-top-20 u-margin-bottom-20"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/creer-une-annonce",
      className: "c-btn u-text-center"
    }, "Cr\xE9er une annonce")), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content o-content--account"
    }, /*#__PURE__*/_react.default.createElement(_JobAdsFront.default, null))) : /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex u-content-center u-margin-top-20 u-margin-bottom-20"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Nous avons \xE0 c\u0153ur de vous accompagner au mieux et cette fonction sera accessible une fois que nous aurons pris contact avec vous")));
    return output;
  }
}
exports.default = JobAdCompanyPage;
